// extracted by mini-css-extract-plugin
module.exports = {"head":"e_Nc","title":"e_Oc","thumb":"e_Pc","titleText":"e_Qc","h1":"e_Rc","facts":"e_Sc"};